export default "__VITE_ASSET__510f36f2__"